import { PlaceIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

type Props = {
  title: string;
  subTitle: string;
  icon?: React.JSX.Element;
  bodyColor?: WhooshThemeColors;
  titleColor?: WhooshThemeColors;
  courseMessage: string;
};

export const TimeListInfoCardHeader = ({
  icon,
  title,
  titleColor,
  bodyColor,
  subTitle,
  courseMessage,
}: Props) => {
  return (
    <HStack justifyContent="space-between">
      <HStack alignItems="center">
        {icon ? (
          <Box
            width={10}
            height={10}
            mr={4}
            backgroundColor="surface-primary"
            borderRadius={"2"}
            justifyContent="center"
            alignItems="center"
          >
            {icon}
          </Box>
        ) : null}
        <Box>
          {title ? (
            <Text variant="mainSmallSemiBold" color={titleColor}>
              {title || ""}
            </Text>
          ) : null}
          {subTitle ? (
            <Text variant="mainTiny" color={bodyColor}>
              {subTitle || ""}
            </Text>
          ) : null}
        </Box>
      </HStack>
      {courseMessage ? (
        <HStack justifyContent="center" alignItems="center" gap={1}>
          <Text variant="mainTiny" fontWeight={600}>
            {courseMessage}
          </Text>
          <PlaceIcon color="black" fill="black" />
        </HStack>
      ) : null}
    </HStack>
  );
};
